import { COLLECTIONS } from "constants/action-types";

export const calculateAllCollectionBudgets = (collectionId) => ({
    type: COLLECTIONS.COLLECTION.BUDGET.CALCULATE.CALCULATE_ALL_START,
    payload: { collectionId },
});

export const calculateCollectionBudget = (budgetId, collectionId) => ({
    type: COLLECTIONS.COLLECTION.BUDGET.CALCULATE.START,
    payload: { collectionId, budgetId },
});
